// ============================================================
//  src/admin/adminConfig.js
//  ─────────────────────────────────────────────────────────
//  SINGLE SOURCE OF TRUTH for the admin base URL.
//
//  To change the admin URL, edit ONLY this one line:
//
//      export const ADMIN_BASE = '/your-new-admin-url';
//
//  It will update everywhere automatically — the router,
//  all navigation, sidebar links, login redirects, etc.
// ============================================================

export const ADMIN_BASE = '/paxpay-admin';

// ── Helpers (use these instead of string-building manually) ─

/** Full path: ADMIN_BASE + sub-path  e.g. adminPath('/dashboard') */
export const adminPath = (sub = '') => `${ADMIN_BASE}${sub}`;
